import "@/App.css";
import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AnimatePresence, motion } from "framer-motion";
import { Layout } from "./components/layout/Layout";
import { LoadingScreen } from "./components/LoadingScreen";
import { Home } from "./pages/Home";
import { About } from "./pages/About";
import { Companies } from "./pages/Companies";
import { Products } from "./pages/Products";
import { OnlineStore } from "./pages/OnlineStore";
import { MakSpareParts } from "./pages/companies/MakSpareParts";
import { Hayalogix } from "./pages/companies/Hayalogix";
import { BrightPerfect } from "./pages/companies/BrightPerfect";
import { HammerMount } from "./pages/companies/HammerMount";
import { BearingsCategory } from "./pages/categories/BearingsCategory";
import { BrakingSteeringCategory } from "./pages/categories/BrakingSteeringCategory";

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Show loading screen for 2.5 seconds
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="App">
      <AnimatePresence mode="wait">
        {isLoading ? (
          <LoadingScreen key="loading" />
        ) : (
          <motion.div
            key="content"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            <BrowserRouter>
              <Toaster 
                position="top-right" 
                toastOptions={{
                  style: {
                    background: '#18181B',
                    color: '#fff',
                    border: '1px solid #27272A',
                  },
                }}
              />
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/companies" element={<Companies />} />
                  <Route path="/companies/mak-spare-parts" element={<MakSpareParts />} />
                  <Route path="/companies/hayalogix" element={<Hayalogix />} />
                  <Route path="/companies/bright-perfect" element={<BrightPerfect />} />
                  <Route path="/companies/hammer-mount" element={<HammerMount />} />
                  <Route path="/products" element={<Products />} />
                  <Route path="/online-store" element={<OnlineStore />} />
                  <Route path="/online-store/bearings" element={<BearingsCategory />} />
                  <Route path="/online-store/braking-steering" element={<BrakingSteeringCategory />} />
                </Routes>
              </Layout>
            </BrowserRouter>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;
